import { createSlice } from "@reduxjs/toolkit";
import {
  fetchKpisThunk,
  fetchChartDataThunk,
  exportChartThunk,
} from "../thunks/analyticsThunks";

const initialState = {
  kpis: {
    sentToday: 0,
    totalSent: 0,
    deliveryRate: 0,
    openRate: 0,
    clickRate: 0,
  },
  chartData: {
    timeSeries: [],
    funnel: [],
    heatMap: [],
    topTemplates: [],
  },
  filters: {
    dateRange: {
      start: null,
      end: null,
    },
    groupBy: "day",
    platform: "all",
  },
  loading: false,
  error: null,
};

const analyticsSlice = createSlice({
  name: "notificationAnalytics",
  initialState,
  reducers: {
    setAnalyticsFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearAnalyticsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch KPIs
    builder
      .addCase(fetchKpisThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchKpisThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.kpis = action.payload;
      })
      .addCase(fetchKpisThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Fetch chart data
    builder
      .addCase(fetchChartDataThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchChartDataThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { chartType, data } = action.payload;
        state.chartData[chartType] = data;
      })
      .addCase(fetchChartDataThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Export chart
    builder
      .addCase(exportChartThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(exportChartThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(exportChartThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setAnalyticsFilters, clearAnalyticsError } =
  analyticsSlice.actions;

export default analyticsSlice.reducer;
